import { render, staticRenderFns } from "./xmyjxjs.vue?vue&type=template&id=51a15fbc&scoped=true&"
import script from "./xmyjxjs.vue?vue&type=script&lang=js&"
export * from "./xmyjxjs.vue?vue&type=script&lang=js&"
import style0 from "./xmyjxjs.vue?vue&type=style&index=0&id=51a15fbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a15fbc",
  null
  
)

export default component.exports